import {preloader} from '../utils/utils';

export default function BlockAsariLatestOffers() {
  let itemDOM = document.querySelector('.asari-latest-offers.loading .ajax-content');
  if(!itemDOM) {
    return;
  }
  let preloaderDOM = document.querySelector('.asari-latest-offers .preloader');
  let xhr = new XMLHttpRequest();
  if(itemDOM.innerHTML !== '') {
    preloader(false,preloaderDOM);
    return true;
  }
  xhr.open('POST', '/wp/wp-admin/admin-ajax.php');
  //xhr.responseType = 'json';
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
  xhr.send('action=block_latest_offers');
  xhr.onload = function() {
    if (xhr.status != 200) {
      console.error(`Error ${xhr.status}: ${xhr.statusText}`); // e.g. 404: Not Found
    } else {
      itemDOM.innerHTML = xhr.responseText;
      setTimeout(function() {
        preloader(false,preloaderDOM);
        itemDOM.classList.remove('loading');
        itemDOM.classList.add('ready')
      }, 25);
    }
  }
  xhr.onerror = function() {
    console.log("Request failed");
  }
}